module.exports = __webpack_public_path__ + "img/fendi.212c8f07.svg";